import { render, staticRenderFns } from "./wsToggle.vue?vue&type=template&id=578d16f5&scoped=true&"
import script from "./wsToggle.vue?vue&type=script&lang=js&"
export * from "./wsToggle.vue?vue&type=script&lang=js&"
import style0 from "./wsToggle.vue?vue&type=style&index=0&id=578d16f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578d16f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VSheet})
